"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6442],{

/***/ 39806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ViewPort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);


function ViewPort(props) {
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((props === null || props === void 0 ? void 0 : props.viewPort) ? props.viewPort : false), inViewPort = ref[0], setInViewPort = ref[1];
    // CHECK IF WHOLE ELEMENT IS IN VIEWPORT
    // const inWholeViewPortUpdate = useCallback( ( myRef, windowWidth, windowHeight ) => {
    //   let refDiv;
    //   if ( myRef.current ) {
    //     refDiv = myRef.current.getBoundingClientRect();
    //     if ( refDiv.top >= 0 && refDiv.left >= 0 && refDiv.right <= windowWidth && refDiv.bottom <= ( windowHeight - refDiv.bottom ) ) {
    //       setInViewPort( true );
    //     } else {
    //       setInViewPort( false );
    //     }
    //   }
    // }, []);
    // CHECK IF ANY PART OF THE ELEMENT IS IN VIEWPORT
    var inAnyViewPortUpdate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(myRef, windowWidth, windowHeight, windowPageXOffset, windowPageYOffset) {
        var refDiv;
        if (myRef.current) {
            refDiv = myRef.current;
            var top = refDiv.offsetTop;
            var left = refDiv.offsetLeft;
            var width = refDiv.offsetWidth;
            var height = refDiv.offsetHeight;
            while(refDiv.offsetParent){
                refDiv = refDiv.offsetParent;
                top += refDiv.offsetTop;
                left += refDiv.offsetLeft;
            }
            if (top < windowPageYOffset + windowHeight && left < windowPageXOffset + windowWidth && top + height > windowPageYOffset && left + width > windowPageXOffset) {
                setInViewPort(true);
            }
        // else {
        //     setInViewPort(false);
        // }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (document !== undefined && window !== undefined) {
            inAnyViewPortUpdate(myRef, window.innerWidth, window.innerHeight, window.pageXOffset, window.pageYOffset);
            window.addEventListener("scroll", function() {
                inAnyViewPortUpdate(myRef, this.innerWidth, this.innerHeight, this.pageXOffset, this.pageYOffset);
            });
        }
    }, [
        inAnyViewPortUpdate
    ]);
    if (!inViewPort) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: props.id ? props.id : "",
            ref: myRef,
            className: props === null || props === void 0 ? void 0 : props.parentClassName,
            children: props === null || props === void 0 ? void 0 : props.skeletonItem
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.children
    });
}


/***/ }),

/***/ 46532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(38751);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(37130);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(2753);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/TextField/TextField.js + 40 modules
var TextField = __webpack_require__(91255);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(8031);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/node_modules/@mui/x-date-pickers/AdapterDateFns/index.js + 131 modules
var AdapterDateFns = __webpack_require__(83796);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/DesktopDateRangePicker/DesktopDateRangePicker.js + 3 modules
var DesktopDateRangePicker = __webpack_require__(10071);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/x-date-pickers-pro/MobileDateRangePicker/MobileDateRangePicker.js + 5 modules
var MobileDateRangePicker = __webpack_require__(41941);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
;// CONCATENATED MODULE: ./components/contact/partials/CalendarArrival.tsx











function CalendarArrival(props) {
    if (!Checkers/* default.isValidObj */.Z.isValidObj(props, "calendar")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden-xs hidden-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: props.calendar.customTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDateRangePicker/* DesktopDateRangePicker */.W, {
                            startText: "Add dates",
                            calendars: 1,
                            value: props.calendar.value,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={false}
                            showDaysOutsideCurrentMonth: true,
                            onChange: function(newValue) {
                                props.calendar.setValue(newValue);
                                if (newValue[0] != null) {
                                    props.calendar.arrival = new Date(newValue[0]).getDate() + "/" + (new Date(newValue[0]).getMonth() + 1) + "/" + new Date(newValue[0]).getFullYear();
                                    props.calendar.setArrival(props.calendar.arrival);
                                }
                                if (newValue[1] != null) {
                                    props.calendar.departure = new Date(newValue[1]).getDate() + "/" + (new Date(newValue[1]).getMonth() + 1) + "/" + new Date(newValue[1]).getFullYear();
                                    props.calendar.setDeparture(props.calendar.departure);
                                }
                            },
                            renderInput: function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "visible-xs visible-sm visible-md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: props.calendar.customTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDateRangePicker/* MobileDateRangePicker */.a, {
                            startText: "Add dates",
                            // clearable={true}
                            // clearText={'Clear'}
                            showToolbar: false,
                            value: props.calendar.value,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={true}
                            showDaysOutsideCurrentMonth: true,
                            onChange: function(newValue) {
                                props.calendar.setValue(newValue);
                                if (newValue[0] != null) {
                                    props.calendar.arrival = new Date(newValue[0]).getDate() + "/" + (new Date(newValue[0]).getMonth() + 1) + "/" + new Date(newValue[0]).getFullYear();
                                    props.calendar.setArrival(props.calendar.arrival);
                                }
                                if (newValue[1] != null) {
                                    props.calendar.departure = new Date(newValue[1]).getDate() + "/" + (new Date(newValue[1]).getMonth() + 1) + "/" + new Date(newValue[1]).getFullYear();
                                    props.calendar.setDeparture(props.calendar.departure);
                                }
                            },
                            renderInput: function(startProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, startProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/contact/partials/CalendarDeparture.tsx











function CalendarDeparture(props) {
    if (!Checkers/* default.isValidObj */.Z.isValidObj(props, "calendar")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden-xs hidden-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: props.calendar.customTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDateRangePicker/* DesktopDateRangePicker */.W, {
                            endText: "Add dates",
                            calendars: 1,
                            value: props.calendar.value,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={false}
                            showDaysOutsideCurrentMonth: true,
                            onChange: function(newValue) {
                                props.calendar.setValue(newValue);
                                if (newValue[0] != null) {
                                    props.calendar.arrival = new Date(newValue[0]).getDate() + "/" + (new Date(newValue[0]).getMonth() + 1) + "/" + new Date(newValue[0]).getFullYear();
                                    props.calendar.setArrival(props.calendar.arrival);
                                }
                                if (newValue[1] != null) {
                                    props.calendar.departure = new Date(newValue[1]).getDate() + "/" + (new Date(newValue[1]).getMonth() + 1) + "/" + new Date(newValue[1]).getFullYear();
                                    props.calendar.setDeparture(props.calendar.departure);
                                }
                            },
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, endProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "visible-xs visible-sm visible-md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: props.calendar.customTheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDateRangePicker/* MobileDateRangePicker */.a, {
                            endText: "Add dates",
                            // clearable={true}
                            // clearText={'Clear'}
                            showToolbar: false,
                            value: props.calendar.value,
                            minDate: new Date(),
                            inputFormat: "dd/MM/yyyy",
                            // disableCloseOnSelect={true}
                            showDaysOutsideCurrentMonth: true,
                            onChange: function(newValue) {
                                props.calendar.setValue(newValue);
                                if (newValue[0] != null) {
                                    props.calendar.arrival = new Date(newValue[0]).getDate() + "/" + (new Date(newValue[0]).getMonth() + 1) + "/" + new Date(newValue[0]).getFullYear();
                                    props.calendar.setArrival(props.calendar.arrival);
                                }
                                if (newValue[1] != null) {
                                    props.calendar.departure = new Date(newValue[1]).getDate() + "/" + (new Date(newValue[1]).getMonth() + 1) + "/" + new Date(newValue[1]).getFullYear();
                                    props.calendar.setDeparture(props.calendar.departure);
                                }
                            },
                            renderInput: function(startProps, endProps) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, endProps), {
                                        autoComplete: "off"
                                    }))
                                });
                            }
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/lab/Alert/Alert.js + 7 modules
var Alert = __webpack_require__(62415);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-duotone-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(57539);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(31390);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/async-creatable/dist/react-select.esm.js + 1 modules
var react_select_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
;// CONCATENATED MODULE: ./components/contact/ContactForm.tsx









// const ReCAPTCHA = React.lazy(() => import('react-google-recaptcha'));













function ContactForm(props) {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var captchaSiteKeySelector = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["captchaSiteKey"];
    });
    var captchaSiteKey = props.captchaSiteKey != undefined ? props.captchaSiteKey : captchaSiteKeySelector;
    var contactAskName = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "contactAskName");
    });
    var contactAskEmail = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "contactAskEmail");
    });
    var contactAskPhone = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "contactAskPhone");
    });
    var contactAskDatesSelector = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "contactAskDates");
    });
    var contactAskDates = props.showDates != undefined ? props.showDates : contactAskDatesSelector;
    var contactAskDestinationSelector = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "contactAskDestination");
    });
    var contactAskDestination = props.showDestination != undefined ? props.showDestination : contactAskDestinationSelector;
    // useEffect( () => {
    //   console.log("forDebug", contactAskName, contactAskEmail, contactAskPhone, contactAskDates, contactAskDestination)
    // })
    //----------------CALENDAR INIT STYLES------------------
    var calendarMaterialTheme = (0,createTheme/* default */.Z)({
        components: {
            MuiFormLabel: {
                styleOverrides: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    root: {
                        position: "absolute !important",
                        marginLeft: "-14px !important",
                        marginTop: "-16px !important",
                        fontSize: "14px !important",
                        opacity: "1 !important",
                        color: "#999!important"
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    shrink: {
                        display: "none!important"
                    }
                }
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        width: "-webkit-fill-available"
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    input: {
                        padding: "1px 0",
                        fontSize: "14px",
                        color: "#000"
                    },
                    notchedOutline: {
                        display: "none!important"
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        margin: "15px 0 35px 0",
                        borderRadius: props.searchbarRadius != null ? props.searchbarRadius + "px" : "10px"
                    }
                }
            }
        }
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([
        null,
        null
    ]), 2), value = ref[0], setValue = ref[1];
    var setOpen = (0,react.useState)(false);
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), arrival = ref1[0], setArrival = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), departure = ref2[0], setDeparture = ref2[1];
    var calendar = {
        value: value,
        setValue: setValue,
        arrival: arrival,
        setArrival: setArrival,
        departure: departure,
        setDeparture: setDeparture,
        customTheme: calendarMaterialTheme
    };
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var ref3 = (0,react.useState)(false), showResponseMessage = ref3[0], setShowResponseMessage = ref3[1];
    var ref4 = (0,react.useState)(null), formSuccess = ref4[0], setFormSuccess = ref4[1];
    var ref5 = (0,react.useState)(false), formSubmitting = ref5[0], setFormSubmitting = ref5[1];
    var recaptchaRef = /*#__PURE__*/ react.createRef();
    var ref6 = (0,react.useState)(0), reCaptchaValiddation = ref6[0], setReCaptchaValiddation = ref6[1];
    var servicesGoogleTagManagerId = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "servicesGoogleTagManagerId");
    });
    var datalayer = window.dataLayer;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var recaptchaValue, data, formObject, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setFormSubmitting(true);
                        recaptchaValue = recaptchaRef.current.getValue();
                        if (recaptchaValue.length === 0) {
                            setReCaptchaValiddation(2);
                            setFormSubmitting(false);
                            return [
                                2
                            ];
                        } else {
                            setReCaptchaValiddation(1);
                        }
                        data = new FormData(event.currentTarget);
                        formObject = Object.fromEntries(data.entries());
                        formObject.arrival = arrival;
                        formObject.departure = departure;
                        if (Checkers/* default.isValidNumber */.Z.isValidNumber(props.experienceId) && Checkers/* default.isValidString */.Z.isValidString(props.experienceTitle)) {
                            formObject.experienceId = props.experienceId.toString();
                            formObject.experienceTitle = props.experienceTitle;
                        }
                        return [
                            4,
                            (0,client/* sendContactForm */.mM)({
                                "page_id": pageId
                            }, formObject)
                        ];
                    case 1:
                        response = _state.sent();
                        setShowResponseMessage(true);
                        if (response.success == 1) {
                            setFormSuccess(true);
                            if (Checkers/* default.isValidString */.Z.isValidString(servicesGoogleTagManagerId)) {
                                datalayer.push({
                                    "event": "contact_form_submission",
                                    "pagePath": router.asPath
                                });
                            }
                            !props.insideSingleProperty ? router.push("/contact/success") : dispatch((0,actions/* setIsSuccess */.SX)(true));
                        } else {
                            setFormSuccess(false);
                        }
                        setFormSubmitting(false);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        event.target.reset();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    var ref7 = (0,react.useState)(null), defaultSearchOptions = ref7[0], setDefaultSearchOptions = ref7[1];
    (0,react.useEffect)(function() {
        (0,client/* getSearchDefaultOptionsAction */.cG)(pageId, window.location.pathname).then(function(response) {
            setDefaultSearchOptions(response.options);
            if (response.defaultLocationValue != undefined) {
                setSelectedSearchLocation(response.defaultLocationValue);
            } else {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                if (customOption.value != null) {
                    setSelectedSearchLocation(customOption);
                }
            }
        });
    }, [
        pageId
    ]);
    var loadSearchOptions = function(inputValue, callback) {
        (0,client/* loadSearchOptionsAction */.gV)(pageId, inputValue, callback);
    };
    var ref8 = (0,react.useState)(null), selectedSearchLocation = ref8[0], setSelectedSearchLocation = ref8[1];
    var handleInputChange = function(input) {
        setSelectedSearchLocation(input);
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
    // switch ( location_type ) {
    //   case 'property':
    //     location.href = window.location.origin + "/property/" + location_id;
    //     break;
    // }
    };
    var colourStyles = {
        control: function(styles) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
                backgroundColor: "transparent",
                border: "none !important",
                boxShadow: "none !important"
            });
        }
    };
    var getContainerClass = function() {
        if (props.containerClass != undefined && Checkers/* default.isValidString */.Z.isValidString(props.containerClass)) {
            return props.containerClass;
        }
        return "col-12 col-sm-12 col-md-6 ps-md-5";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: getContainerClass(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fw-normal text-master",
                children: "Fill up this form to contact us if you have any further questions"
            }),
            showResponseMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: formSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "success",
                    sx: {
                        mb: "20px"
                    },
                    children: "Contact form was submitted successfully"
                }) : formSuccess != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    sx: {
                        mb: "20px"
                    },
                    children: "There was a problem while submitting contact form"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            reCaptchaValiddation == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                severity: "warning",
                sx: {
                    mb: "20px"
                },
                children: "You must click the reCaptcha button!"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    contactAskName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "first_name",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "First name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "first_name",
                                            name: "first_name",
                                            type: "text",
                                            className: "form-control",
                                            required: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "last_name",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "Last name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "last_name",
                                            name: "last_name",
                                            type: "text",
                                            className: "form-control"
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            contactAskEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: contactAskPhone ? "col-6 col-md-6" : "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "email",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "email",
                                            name: "email",
                                            type: "email",
                                            className: "form-control",
                                            placeholder: "You will get your reply to this email",
                                            required: true
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            contactAskPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: contactAskEmail ? "col-6 col-md-6" : "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "phone",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "Phone"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "phone",
                                            name: "phone",
                                            type: "tel",
                                            className: "form-control",
                                            // pattern="[0-12]{3}"
                                            placeholder: "Phone with Country Code",
                                            required: true
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    contactAskDestination && !props.insideSingleProperty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-group form-group-default bg-white b-transparent-master ".concat(props.insideSingleProperty ? "" : "required", " "),
                                style: {
                                    overflow: "visible",
                                    zIndex: 99
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "destination",
                                        className: "bold text-uppercase letter-sp-normal fs-12",
                                        children: "Destination/Property"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
                                        noOptionsMessage: function() {
                                            return "nothing found";
                                        },
                                        loadingMessage: function() {
                                            return "searching...";
                                        },
                                        cacheOptions: false,
                                        defaultOptions: defaultSearchOptions,
                                        loadOptions: loadSearchOptions,
                                        onChange: handleInputChange,
                                        // defaultValue={defaultLocationValue}
                                        value: selectedSearchLocation,
                                        className: "SearchBar-Form__form-group-select",
                                        id: "location_property",
                                        name: "location_property",
                                        inputId: "searchright",
                                        formatCreateLabel: function(inputValue) {
                                            return "Search for " + inputValue;
                                        },
                                        instanceId: "location_property",
                                        isSearchable: true,
                                        options: props.options,
                                        // styles={props.customStyles}
                                        styles: colourStyles,
                                        placeholder: "Where are you going",
                                        blurInputOnSelect: true,
                                        menuPlacement: "bottom",
                                        components: {
                                            DropdownIndicator: function() {
                                                return null;
                                            },
                                            IndicatorSeparator: function() {
                                                return null;
                                            }
                                        }
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    contactAskDates ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "email",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "Arrival"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarArrival, {
                                                id: "checkin",
                                                name: "checkin",
                                                calendar: calendar
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6 col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group form-group-default bg-white b-transparent-master required",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "phone",
                                            className: "bold text-uppercase letter-sp-normal fs-12",
                                            children: "Departure"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarDeparture, {
                                                id: "checkout",
                                                name: "checkout",
                                                calendar: calendar
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " form-group form-group-default bg-white b-transparent-master required",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "message",
                                        className: "bold text-uppercase letter-sp-normal fs-12",
                                        children: "Message"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                        className: "form-control",
                                        placeholder: "Type the message you wish to send",
                                        id: "message",
                                        name: "message",
                                        style: {
                                            minHeight: "100px"
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    captchaSiteKey != undefined && captchaSiteKey != null && Checkers/* default.isValidString */.Z.isValidString(captchaSiteKey) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-between w-100 m-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 d-flex justify-content-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                    ref: recaptchaRef,
                                    sitekey: captchaSiteKey
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row justify-content-between w-100 m-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-arial hint-text small pull-left letter-sp-normal fs-12 w-auto m-t-5 px-0",
                                children: "I certify that the above information is accurate and true."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                id: "contact_submit",
                                className: "btn btn-design-color w-auto text-uppercase letter-sp-normal fw-normal",
                                disabled: formSubmitting,
                                style: {
                                    padding: "6px 17px"
                                },
                                children: [
                                    formSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: faSpinner/* faSpinner */.LM,
                                        spin: true,
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 92288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);


var Consts = /*#__PURE__*/ function() {
    "use strict";
    function Consts() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Consts);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Consts, null, [
        {
            key: "S3",
            get: function get() {
                return "https://loggia-cdn.s3.eu-central-1.amazonaws.com/";
            }
        },
        {
            key: "S3Folder",
            get: function get() {
                return "shared/";
            }
        },
        {
            key: "AppleAppSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "ios_en.svg";
            }
        },
        {
            key: "AndroidAppSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "android_en.svg";
            }
        },
        {
            key: "W3cValidatorSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "w3c_xhtml_2.0.svg";
            }
        },
        {
            key: "WcagValidatorSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "w3c_wcag_1.0.svg";
            }
        },
        {
            key: "JumbotronCarouselImage",
            get: function get() {
                return 486;
            }
        },
        {
            key: "JumbotronGridImage",
            get: function get() {
                return 573;
            }
        },
        {
            key: "JumbotronStaticImage",
            get: function get() {
                return 487;
            }
        }
    ]);
    return Consts;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Consts);


/***/ })

}]);